import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const SubSectionIndex = () => {
    const navigate = useNavigate();

    // Configuração de filtros específica para SubSectionKPI
    const filterConfig = useMemo(() => [        
        {
            type: "text",
            name: "description",
            label: "Description",
            placeholder: "Description..."
        },
        {
            type: "text",
            name: "sectionDescription",
            label: "Section Description",
            placeholder: "Section Description..."
        },
        {
            type: "text",
            name: "moduleDescription",
            label: "Module Description",
            placeholder: "Module Description..."
        },
        {
            type: "text",
            name: "operationDescription",
            label: "Operation Description",
            placeholder: "Operation Description..."
        }
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [
        {
            title: "Form",
            dataIndex: "section.module.operation.description",
            key: "section.module.operation.description",
            sortable: true 
        },
        {
            title: "Module",
            dataIndex: "section.module.description",
            key: "section.module.description",
            sortable: true 
        },
        {
            title: "Section",
            dataIndex: "section.description",
            key: "section.description",
            sortable: true 
        },
        { 
            title: 'Description', 
            dataIndex: 'description', 
            key: 'description', 
            sortable: true 
        },
        { 
            title: 'Order', 
            dataIndex: 'order', 
            key: 'order', 
            sortable: true,
            width: 100
        },        
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 80,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/subSection/edit/${record.subSectionID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="SubSection"
            apiEndpoint="/SubSection/getAllPaginated"
            toggleActiveEndpoint="/subSection/toggleActive"
            toggleDeletedEndpoint="/subSection/toggleDeleted"
            newRoute="/subSection/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="subSectionID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default SubSectionIndex;
